import { Subject } from 'interfaces/Subject'
import Link from 'next/link'
import { searchResultRouteOptions } from 'lib/constants/routes'
import SubjectBody from './SubjectBody'

interface Props {
    subject: Subject
    isSelected?: boolean
    to?: string
    showTitleAsSubHeadline?: boolean
    isDarkTheme?: boolean
}

const SubjectCard = (props: Props) => {
    return (
        <Link href={props.to ?? searchResultRouteOptions('', props.subject.id)} key={props.subject.id}>
            <SubjectBody {...props} />
        </Link>
    )
}

export default SubjectCard
